<div>
	{{ '_ws-framework.pagination.showing' | translate }} {{ firstEntry }}
	{{ '_ws-framework.pagination.to' | translate }} {{ lastEntry }} {{ '_ws-framework.pagination.of' | translate }}
	{{ totalData }}
	{{ '_ws-framework.pagination.entries' | translate }}
</div>
